var render = function render(){var _vm=this,_c=_vm._self._c;return _c('customer-care-login-cmp',_vm._b({staticClass:"CustomerCareLoginCmpExtended",scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true)},'customer-care-login-cmp',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }